import { Form, FormInstance, Spin, Tabs, TabsProps } from 'antd';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import Activity from '../../components/Activity/Activity';
import Attachments from '../../components/Attachments/Attachments';
import FieldColor from '../../components/fieldColor';
import WrapperTwoColumn from '../../components/WrapperTwoColumn';
import useAccessForTask from '../../hooks/useAccessForTask';
import { FieldPhase, FieldProject, useAccess } from '../../index';
import { RootState } from '../../store';
import { ItemTaskType } from '../../types';
import FieldContractInvoice from './fieldContractInvoice';
import FieldCostCode from './fieldCostCode';
import FieldDivision from './fieldDivision';
import FieldParent from './fieldParent';
import FieldSubTask from './fieldSubtask';
import FieldWoSi from './fieldWoSi';

interface ITabsItems {
    form: FormInstance;
    isInFlightUpdate: boolean;
}
const TabsItems: React.FC<ITabsItems> = ({ form, isInFlightUpdate }) => {
    const refListProject = useRef<React.FC<any>>(null);
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);

    const isAccessToEditDetails = useAccessForTask(currentTask, [
        'schedule-task.all.create',
        'schedule-task.owner.create',
        // 'schedule-task.assignee.create',
        'schedule-task.all.edit',
        'schedule-task.owner.edit',
        // 'schedule-task.assignee.edit',
        'schedule-task.all.manage',
        'schedule-task.owner.manage',
        // 'schedule-task.assignee.manage',
    ]);

    const isAccessAssignee = useAccessForTask(currentTask, ['schedule-task.all.view', 'schedule-task.owner.view']);

    const isAccessActivity = {
        create: useAccessForTask(currentTask, [
            'schedule-task.view',
            'schedule-task.owner.view',
            'schedule-task.assignee.view',
            'schedule-task.owner.create',
            'schedule-task.assignee.create',
            'schedule-task.owner.edit',
            'schedule-task.assignee.edit',
        ]),
    };

    const isAccessAttachments = {
        create: useAccess(['schedule-task']),
        delete: useAccessForTask(currentTask, [
            'schedule-task.all.manage',
            'schedule-task.owner.manage',
            // 'schedule-task.assignee.manage',
        ]),
    };

    const styleCollapseItems = { marginTop: 0, marginBottom: 0 };

    // const projectFilter = { project_id: currentTask?.project_id || '' };

    const filterFlexible = currentTask?.project_id
        ? `[{"or":[{"project_id":"${currentTask?.project_id}"}]}]`
        : undefined;

    const isAccessSubTask = {
        create: useAccessForTask(currentTask, [
            // 'schedule-task.all.create',
            // 'schedule-task.owner.create',
            // 'schedule-task.assignee.create',
            'schedule-task.all.edit',
            'schedule-task.owner.edit',
            'schedule-task.assignee.edit',
            'schedule-task.assignee.create',
        ]),
        update: useAccessForTask(currentTask, ['schedule-task.owner.view', 'schedule-task.assignee.view']),
        delete: useAccessForTask(currentTask, [
            'schedule-task.all.manage',
            'schedule-task.owner.manage',
            'schedule-task.assignee.manage',
        ]),
    };

    const tabsItems: TabsProps['items'] = [
        {
            key: '1',
            label: 'Subtasks',
            children: (
                <Form name="taskItemFor4" layout="vertical" form={form} autoComplete="off">
                    <Spin spinning={isInFlightUpdate}>
                        <FieldSubTask isAccess={isAccessSubTask} />
                    </Spin>
                </Form>
            ),
            forceRender: true,
        },
        isAccessAssignee || isAccessToEditDetails
            ? {
                  key: '2',
                  label: 'Details',
                  children: (
                      <Form name="taskItemFor3" layout="vertical" form={form} autoComplete="off">
                          <WrapperTwoColumn
                              childFirstColumn={
                                  <>
                                      <FieldProject<ItemTaskType>
                                          name={'project_id'}
                                          required={false}
                                          disabled={!isAccessToEditDetails}
                                          ref={refListProject as any}
                                      />
                                      <FieldParent
                                          // localFilters={projectFilter}
                                          filterFlexible={filterFlexible}
                                          disabled={!currentTask?.project_id || !isAccessToEditDetails}
                                      />
                                      <FieldDivision disabled={!isAccessToEditDetails} />
                                      <FieldContractInvoice disabled={!isAccessToEditDetails} />
                                  </>
                              }
                              childSecondColumn={
                                  <>
                                      <FieldPhase<ItemTaskType>
                                          parentRef={refListProject as any}
                                          name={'phase_id'}
                                          disabled={true}
                                      />
                                      <FieldColor
                                          disabled={!!currentTask?.schedule_item_id || !isAccessToEditDetails}
                                      />
                                      <FieldCostCode disabled={!isAccessToEditDetails} />
                                      <FieldWoSi disabled={!isAccessToEditDetails} />
                                  </>
                              }
                              style={styleCollapseItems}
                          />
                      </Form>
                  ),
                  forceRender: true,
              }
            : ({} as any),
        {
            key: '3',
            label: 'Activities',
            children: currentTask && (
                <div style={{ margin: '12px 0' }}>
                    <Activity model_id={currentTask.id} model_type={'Task'} isAccess={isAccessActivity} />
                </div>
            ),
            forceRender: true,
        },
        {
            key: '4',
            label: 'Attachments',
            children: currentTask && (
                <div style={{ margin: '12px 0' }}>
                    <Attachments model_id={currentTask.id} model_type={'Task'} isAccess={isAccessAttachments} />
                </div>
            ),
            forceRender: true,
        },
    ];

    return (
        <Tabs defaultActiveKey="1" items={tabsItems} centered type="card" size={'small'} style={{ marginTop: 10 }} />
    );
};

export default React.memo(TabsItems);
